<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="far fa-bullhorn" class="q-mb-sm" /> {{ $t('campaigns') }}
		</div>

		<q-tabs v-model="tab">
			<q-tab slot="title" name="basic_data" :label="$t('basic_data')" />
			<q-tab slot="title" v-if="showTab" name="levels" :label="$t('levels')" />
			<q-tab
				slot="title"
				v-if="showTab"
				name="company_branches"
				:label="`${$t('company_branches')} (${company_branches.length})`"
				:color="error_company_branches ? 'negative' : ''"
			/>
			<q-tab
				slot="title"
				v-if="showTab"
				name="brands"
				:label="`${$t('brands')} (${brands.length})`"
				:color="error_brands ? 'negative' : ''"
				:disable="!allow_sells"
			/>
			<q-tab
				slot="title"
				v-if="showTab"
				name="product_types"
				:label="`${$t('product_types')} (${product_types.length})`"
				:color="error_product_types ? 'negative' : ''"
				:disable="!allow_sells"
			/>
			<q-tab
				slot="title"
				v-if="showTab"
				name="products"
				:label="`${$t('products')} (${products.length})`"
				:color="error_products ? 'negative' : ''"
				:disable="!allow_sells"
			/>
			<q-tab
				slot="title"
				v-if="showTab"
				name="rewards"
				:label="`${$t('rewards')} (${rewards.length})`"
				:color="error_rewards ? 'negative' : ''"
			/>
			<q-tab
				slot="title"
				v-if="showTab"
				name="photo_types"
				:label="`${$t('photo_types')} (${photo_types.length})`"
			/>
			<q-tab
				slot="title"
				v-if="showTab"
				name="configure_and_publish"
				:label="$t('configure_and_publish')"
			/>
			<q-tab slot="title" v-if="showTab" name="audience" :label="$t('audience')" />

			<q-tab-pane name="basic_data">
				<basic-data />
			</q-tab-pane>

			<q-tab-pane name="levels">
				<levels />
			</q-tab-pane>

			<q-tab-pane name="company_branches">
				<company-branches />
			</q-tab-pane>

			<q-tab-pane name="brands">
				<brands />
			</q-tab-pane>

			<q-tab-pane name="product_types">
				<product-types />
			</q-tab-pane>

			<q-tab-pane name="products">
				<products />
			</q-tab-pane>

			<q-tab-pane name="rewards">
				<rewards />
			</q-tab-pane>

			<q-tab-pane name="photo_types">
				<photo-types />
			</q-tab-pane>

			<q-tab-pane name="configure_and_publish">
				<configure-and-publish />
			</q-tab-pane>

			<q-tab-pane name="audience">
				<audience />
			</q-tab-pane>
		</q-tabs>
	</q-page>
</template>

<script>
import BasicData from 'components/admin/campaigns/BasicData'
import Levels from 'components/admin/campaigns/Levels'
import CompanyBranches from 'components/admin/campaigns/CompanyBranches'
import Brands from 'components/admin/campaigns/Brands'
import ProductTypes from 'components/admin/campaigns/ProductTypes'
import Products from 'components/admin/campaigns/Products'
import Rewards from 'components/admin/campaigns/Rewards'
import PhotoTypes from 'components/admin/campaigns/PhotoTypes'
import ConfigureAndPublish from 'components/admin/campaigns/ConfigureAndPublish'
import Audience from 'components/admin/campaigns/Audience'
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'profile', 'training', 'admin', 'rewards'] },

	data() {
		return {
			tab: 'basic_data',
		}
	},

	components: {
		'basic-data': BasicData,
		levels: Levels,
		'company-branches': CompanyBranches,
		brands: Brands,
		'product-types': ProductTypes,
		products: Products,
		'configure-and-publish': ConfigureAndPublish,
		rewards: Rewards,
		'photo-types': PhotoTypes,
		audience: Audience,
	},

	computed: {
		...mapGetters({
			allow_sells: 'campaigns/allow_sells',
			access_token: 'common/access_token',
			id: 'campaigns/id',
			company_branches: 'campaigns/company_branches',
			brands: 'campaigns/brands',
			product_types: 'campaigns/product_types',
			products: 'campaigns/products',
			rewards: 'campaigns/rewards',
			photo_types: 'campaigns/photo_types',
			error_company_branches: 'campaigns/error_company_branches',
			error_brands: 'campaigns/error_brands',
			error_product_types: 'campaigns/error_product_types',
			error_products: 'campaigns/error_products',
			error_rewards: 'campaigns/error_rewards',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		showTab() {
			if (this.id != 0) return true
			else return false
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_rewards/campaigns/${this.id}/`, this.getHeader)
				.then((response) => {
					this.$store.dispatch('campaigns/SET_CAMPAIGN', [
						response.data.title,
						response.data.sub_title,
						response.data.description,
						response.data.campaign_url,
						moment(response.data.start_date).format('YYYY-MM-DDT12:00:00'),
						moment(response.data.end_date).format('YYYY-MM-DDT12:00:00'),
						response.data.image,
						response.data.status,
						response.data.allow_sells,
						response.data.training_kpi_points,
						response.data.training_non_kpi_points,
						response.data.training_special_points,
						response.data.webinar_points,
						response.data.image_banner,
						response.data.areas,
						response.data.profiles,
						response.data.company_branches,
						response.data.brands,
						response.data.product_types,
						response.data.products,
						response.data.rewards,
						response.data.upload_file_types,
					])
					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},
	},

	created() {
		this.$store.dispatch('campaigns/SET_CAMPAIGN', [
			'',
			'',
			'',
			'',
			'',
			'',
			'',
			'',
			false,
			0,
			0,
			0,
			0,
			'',
			[],
			[],
			[],
			[],
			[],
			[],
			[],
			[],
		])
		this.$store.dispatch('campaigns/SET_ERROR_DEFAULT', [false, false, false, false, false])

		if (this.$route.params.id) this.$store.dispatch('campaigns/SET_ID', [this.$route.params.id])
		else this.$store.dispatch('campaigns/SET_ID', [0])

		if (this.id != 0) this.fetchData()
	},
}
</script>

<style></style>
